module.exports = __webpack_public_path__ + "static/media/iconAddPrimary.28b816f1.svg";